import React from 'react';
import { AsideInterface } from '../../state/component/AsideSlice';

//usable components
import VpnPeerContainer from '@containers/assets/VpnPeerContainer';
import { SimMetricsContainer } from '@containers/telecom/sim/SimMetricsContainer';
import VpnUserDetailContainer from '@containers/users/VpnUserDetailContainer';
import ServerDetailContainer from '../../containers/assets/servers/ServerDetailContainer';
import AddHardware from '../../containers/hardware/AddHardware';
import AssetDetailContainer from '../../containers/hardware/HardwareDetailContainer';
import NetworkDeviceDetailContainer from '../../containers/hardware/network/NetworkDeviceDetailContainer';
import AddLicense from '../../containers/licenses/AddLicense';
import CompanyLicenseDetail from '../../containers/licenses/CompanyLicenseDetail';
import CreateLicenseRequest from '../../containers/licenses/CreateLicenseRequest';
import LicenseRequestDetail from '../../containers/licenses/LicenseRequestDetail';
import LicenseStatDetail from '../../containers/licenses/LicenseStatDetails';
import OrderDetailContainer from '../../containers/orders/OrderDetailContainer';
import AddProjectUser from '../../containers/projects/AddProjectUser';
import ProjectDetailContainer from '../../containers/projects/ProjectDetailContainer';
import ProjectTaskDetail from '../../containers/projects/ProjectTaskDetail';
import BranchCreateContainer from '../../containers/settings/branches/BranchCreateContainer';
import BranchDetailContainer from '../../containers/settings/branches/BranchDetailContainer';
import GroupCreateContainer from '../../containers/settings/groups/GroupCreateContainer';
import GroupDetailContainer from '../../containers/settings/groups/GroupDetailContainer';
import UserCreateContainer from '../../containers/settings/users/UserCreateContainer';
import UserDetailContainer from '../../containers/settings/users/UserDetailContainer';
import ShoppingCartAside from '../../containers/shop/cart/ShoppingCartAside';
import RequestNewSimcards from '../../containers/telecom/sim/RequestNewSimcards';
import ActivateSimRequest from '../../containers/telecom/sim/SimActivationContainer';
import SimDetailContainer from '../../containers/telecom/sim/SimDetailContainer';
import CreateTicketContainer from '../../containers/tickets/CreateTicketContainer';
import TicketDetailContainer from '../../containers/tickets/TicketDetailContainer';
import TicketYearOverviewContainer from '../../containers/tickets/TicketYearOverviewContainer';
import TicketDetailWrapper from '../../containers/tickets/Ticketdetail';
import IctOnboardingContainer from '../../containers/users/IctOnboardingContainer';
import LoadingSpinner from '../buttons/LoadingSpinner';
import CmcTask from '../forms/project/CmcTask';
import HardwareOffboarding from '../forms/users/HardwareOffboarding';
import HardwareOnboarding from '../forms/users/HardwareOnboarding';
import ImportUsersForm from '../forms/users/ImportUsers';
import LicenseOffboarding from '../forms/users/LicenseOffboarding';
import LicenseOnboarding from '../forms/users/LicenseOnboarding';
import SimOffboarding from '../forms/users/SimOffboarding';
import FiltersSidebar from '../products/FiltersSidebar';
const components: Record<ComponentKey, React.FC<any>> = {
  default: LoadingSpinner,
  ticket: TicketDetailContainer,
  ticketCreate: CreateTicketContainer,
  ticketYearOverview: TicketYearOverviewContainer,
  simDetail: SimDetailContainer,
  userDetail: UserDetailContainer,
  importUsers: ImportUsersForm,
  userCreate: UserCreateContainer,
  groupDetail: GroupDetailContainer,
  groupCreate: GroupCreateContainer,
  branchDetail: BranchDetailContainer,
  branchCreate: BranchCreateContainer,
  orderDetail: OrderDetailContainer,
  assetDetail: AssetDetailContainer,
  addHardware: AddHardware,
  addLicense: AddLicense,
  requestLicense: CreateLicenseRequest,
  licenseDetail: CompanyLicenseDetail,
  licenseRequestDetail: LicenseRequestDetail,
  telecomOnboard: ActivateSimRequest,
  hardwareOnboard: HardwareOnboarding,
  licenseOnboard: LicenseOnboarding,
  telecomOffboarding: SimOffboarding,
  hardwareOffboarding: HardwareOffboarding,
  licenseOffboarding: LicenseOffboarding,
  filtersSidebar: FiltersSidebar,
  shoppingCart: ShoppingCartAside,
  requestNewSimcards: RequestNewSimcards,
  ActivateSimRequest: ActivateSimRequest,
  BoTicketDetailContainer: TicketDetailWrapper,
  networkDeviceDetailContainer: NetworkDeviceDetailContainer,
  LicenseStatDetail: LicenseStatDetail,
  IctOnboardingContainer: IctOnboardingContainer,
  cmcTask: CmcTask,
  projectUsers: AddProjectUser,
  projectDetail: ProjectDetailContainer,
  projectTaskDetail: ProjectTaskDetail,
  serverDetailContainer: ServerDetailContainer,
  simMetricsContainer: SimMetricsContainer,
  vpnPeerContainer: VpnPeerContainer,
  vpnUserDetailContainer: VpnUserDetailContainer,
};

export type ComponentKey =
  | 'default'
  | 'ticket'
  | 'ticketCreate'
  | 'ticketYearOverview'
  | 'simDetail'
  | 'userDetail'
  | 'importUsers'
  | 'userCreate'
  | 'groupDetail'
  | 'groupCreate'
  | 'branchDetail'
  | 'branchCreate'
  | 'orderDetail'
  | 'assetDetail'
  | 'addHardware'
  | 'addLicense'
  | 'requestLicense'
  | 'licenseDetail'
  | 'licenseRequestDetail'
  | 'telecomOnboard'
  | 'hardwareOnboard'
  | 'licenseOnboard'
  | 'telecomOffboarding'
  | 'hardwareOffboarding'
  | 'licenseOffboarding'
  | 'filtersSidebar'
  | 'shoppingCart'
  | 'requestNewSimcards'
  | 'ActivateSimRequest'
  | 'BoTicketDetailContainer'
  | 'networkDeviceDetailContainer'
  | 'LicenseStatDetail'
  | 'IctOnboardingContainer'
  | 'cmcTask'
  | 'projectUsers'
  | 'projectDetail'
  | 'projectTaskDetail'
  | 'serverDetailContainer'
  | 'simMetricsContainer'
  | 'vpnPeerContainer'
  | 'vpnUserDetailContainer';

export const Aside = ({ component, data, callback, hide }: AsideInterface) => {
  if (hide) return null;

  const Component = components[component];

  return (
    <>
      {data ? (
        <Component data={data} callback={callback} hide={hide} />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default Aside;
